import React, { useState, useMemo, useRef, useEffect } from 'react';
import { FiX, FiSearch } from 'react-icons/fi';
import { useBookletCoupons } from '../../context/BookletCouponsContext';
import CouponItem from './CouponItem';
import { CouponWithCompany } from '../../context/BookletCouponsContext';

interface CouponSelectionProps {
  isOpen: boolean;
  closeCouponSelection: () => void;
  selectedBookletColor: string;
}

const CouponSelection: React.FC<CouponSelectionProps> = ({
  isOpen,
  closeCouponSelection,
  selectedBookletColor,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const searchInputRef = useRef<HTMLInputElement>(null);
  const {
    availableCoupons,
    selectedCoupons,
    setSelectedCoupons,
    selectedCouponIndex,
    companyCategories,
    selectedBooklet,
  } = useBookletCoupons();

  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);

  const handleCouponSelect = (coupon: CouponWithCompany) => {
    const newSelectedCoupons = [...selectedCoupons];
    newSelectedCoupons[selectedCouponIndex] = coupon;
    setSelectedCoupons(newSelectedCoupons);
    closeCouponSelection();
  };

  const filteredCoupons = useMemo(() => {
    if (!searchQuery.trim()) return availableCoupons;

    const query = searchQuery.toLowerCase();
    return availableCoupons.filter(coupon =>
      coupon.discount?.toLowerCase().includes(query) ||
      coupon.description?.toLowerCase().includes(query) ||
      coupon.company?.name?.toLowerCase().includes(query) ||
      coupon.smallTitle?.toLowerCase().includes(query)
    );
  }, [availableCoupons, searchQuery]);

  return (
    <div className="modal-overlay">
      <div className="modal-content coupon-selection-modal">
        <div className="modal-header">
          <h3>Välj kupong</h3>
          <div className="search-container">
            <FiSearch className="search-icon" />
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Sök..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
              style={{ width: '100%', padding: '8px 8px 8px 36px', border: '1px solid #ddd', borderRadius: '4px' }}
            />
          </div>
          <button className="close-btn" onClick={closeCouponSelection} title="Stäng">
            <FiX size={20} />
          </button>
        </div>
        <div className="company-coupons-list">
          {filteredCoupons.map((coupon) => (
            <div
              key={coupon._id}
              className="coupon-item"
              onClick={() => handleCouponSelect(coupon)}
            >
              <CouponItem
                index={-1}
                coupon={coupon}
                onCouponRemove={() => { }}
                bookletColor={selectedBookletColor}
                companyCategories={companyCategories}
                selectedBooklet={selectedBooklet}
              />
            </div>
          ))}
          {filteredCoupons.length === 0 && (
            <p className="no-results">Inga kuponger hittades</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CouponSelection; 
